<p>participant-diagnostic-form-logement works!</p>
